<template>
  <div id="Lgx02728120758340918706823">
    <div class="flex gap-1 mb-1">
      <vs-button :color="selectedPart === 0 ? 'primary' : 'grey'" type="filled" class="mb-2 mr-2" @click="selectedPart = 0"
        >Technologies</vs-button
      >
      <vs-button :color="selectedPart === 1 ? 'primary' : 'grey'" type="filled" class="mb-2 mr-2" @click="selectedPart = 1"
        >Secure Devices</vs-button
      >
    </div>

    <div v-if="selectedPart === 0" class="bg-dark p-12 main-border items-center rounded-lg grid grid-cols-4 gap-6 mt-2">
      <div class="flex items-center gap-2">
        <div class="arrow text-grey" style="width: 50px; margin-right: 0.75rem; line-height: 3rem">Internet</div>

        <v-select
          class="w-full"
          placeholder="Select technology..."
          :options="technologyOptions"
          v-model="partOneAnswers[0].value"
          :class="{
            correct: partOneAnswers[0].correct,
            invalid: partOneAnswers[0].correct === false,
          }"
        />
        <div class="arrow" style="width: 50px"></div>
      </div>
      <v-select
        class="w-full"
        placeholder="Select technology..."
        :options="technologyOptions"
        v-model="partOneAnswers[1].value"
        :class="{
          correct: partOneAnswers[1].correct,
          invalid: partOneAnswers[1].correct === false,
        }"
      />

      <div class="flex flex-col gap-24 relative">
        <span class="h-full w-1 absolute bottom-0 ml-16 bg-grey" />
        <span class="h-full w-1 absolute bottom-0 bg-grey" style="margin-left: 16.5rem" />
        <div class="absolute flex items-center" style="margin-top: 5.5rem; margin-left: 16.6rem">
          <div class="arrow" style="width: 45px"></div>
        </div>

        <v-select
          class="w-full"
          placeholder="Select technology..."
          :options="technologyOptions"
          v-model="partOneAnswers[2].value"
          :class="{
            correct: partOneAnswers[2].correct,
            invalid: partOneAnswers[2].correct === false,
          }"
        />

        <v-select
          class="w-full"
          placeholder="Select technology..."
          :options="technologyOptions"
          v-model="partOneAnswers[3].value"
          :class="{
            correct: partOneAnswers[3].correct,
            invalid: partOneAnswers[3].correct === false,
          }"
        />
      </div>

      <v-select
        class="w-full"
        placeholder="Select technology..."
        :options="technologyOptions"
        v-model="partOneAnswers[4].value"
        :class="{
          correct: partOneAnswers[4].correct,
          invalid: partOneAnswers[4].correct === false,
        }"
      />
    </div>

    <div v-if="selectedPart === 1" class="bg-dark p-6 main-border rounded-lg mt-2">
      <span class="terminal-line text-grey flex items-center gap-3" style="line-height: 2rem">
        openssl req -new -newkey
        <v-select
          style="width: 20rem"
          placeholder="Select command..."
          :options="commandOptions"
          v-model="partTwoAnswers[0].value"
          :class="{
            correct: partTwoAnswers[0].correct,
            invalid: partTwoAnswers[0].correct === false,
          }"
        />
      </span>

      <span class="terminal-line text-grey flex items-center gap-3" style="line-height: 2rem">
        -key /certificate/csr.key -out
        <v-select
          style="width: 20rem"
          placeholder="Select command..."
          :options="commandOptions"
          v-model="partTwoAnswers[1].value"
          :class="{
            correct: partTwoAnswers[1].correct,
            invalid: partTwoAnswers[1].correct === false,
          }"
        />
      </span>

      <span class="terminal-line text-grey flex items-center gap-3" style="line-height: 2rem">
        Generating RSA private key
        <v-select
          style="width: 20rem"
          placeholder="Select command..."
          :options="commandOptions"
          v-model="partTwoAnswers[2].value"
          :class="{
            correct: partTwoAnswers[2].correct,
            invalid: partTwoAnswers[2].correct === false,
          }"
        />
      </span>

      <span class="terminal-line text-grey" style="line-height: 2rem">
        ........................++++<br />
        ------------------------------------+++++<br />
        e is 65537 (0x10001)
      </span>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import MovablePopup from '../../../../../../../../components/popup/MovablePopup';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      selectedPart: 0,

      technologyOptions: ['PKI certificate', 'Web server', 'Firewall', 'WAF', 'Router', 'Switch'],

      commandOptions: [
        '/certificate/example.com.p7b',
        'rsa:2048',
        '2048 bit long modulus',
        '/certificate/example.com.csr',
        '1024 bit long modulus',
        'rsa:1024',
        '/certificate/example.com.pem',
        '/certificate/example.com.crt',
      ],

      partOneAnswers: [
        {
          value: null,
          answer: ['Router'],
          correct: null,
        },
        {
          value: null,
          answer: ['Firewall'],
          correct: null,
        },
        {
          value: null,
          answer: ['WAF', 'PKI certificate'],
          correct: null,
        },
        {
          value: null,
          answer: ['PKI certificate', 'WAF'],
          correct: null,
        },
        {
          value: null,
          answer: ['Web server'],
          correct: null,
        },
      ],

      partTwoAnswers: [
        {
          value: null,
          answer: 'rsa:2048',
          correct: null,
        },
        {
          value: null,
          answer: '/certificate/example.com.csr',
          correct: null,
        },
        {
          value: null,
          answer: '2048 bit long modulus',
          correct: null,
        },
      ],
    };
  },
  methods: {
    markSimulation() {
      let totalScore = 0;

      for (const partItem of this.partOneAnswers) {
        if (partItem.answer.includes(partItem.value)) {
          partItem.correct = true;
          totalScore++;
        } else {
          partItem.correct = false;
        }
      }

      for (const partItem of this.partTwoAnswers) {
        if (partItem.value === partItem.answer) {
          partItem.correct = true;
          totalScore++;
        } else {
          partItem.correct = false;
        }
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }
      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    vSelect,
    MovablePopup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
#Lgx02728120758340918706823 {
  .terminal-line {
    color: #f8f8f2;
    font-family: 'Fira Code', monospace;
    font-size: 0.875rem;
    line-height: 1.5;
    margin: 0.25rem 0;
  }

  .correct {
    border: 1px solid #31b952 !important;
    border-radius: 0.35rem;
  }

  .invalid {
    border: 1px solid #c93738 !important;
    border-radius: 0.35rem;
  }

  .vs-con-input {
    width: 100%;
  }

  .arrow {
    position: relative;
    height: 4px;
    background-color: #b8c2cc;
    display: inline-block;
  }

  .arrow::after {
    content: '';
    position: absolute;
    right: -10px;
    top: -6px;
    width: 0;
    height: 0;
    border-left: 10px solid #b8c2cc;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
  }
}
</style>
